module.exports = __webpack_public_path__ + "img/down-arrow.835e2ff7.svg";